"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkerAuthorization = void 0;
const validation_1 = require("../validation");
var LinkerAuthorization;
(function (LinkerAuthorization) {
    LinkerAuthorization.schema = {
        type: 'object',
        properties: {
            name: { type: 'string' },
            desc: { type: 'string' },
            startDate: { type: 'string', nullable: true },
            endDate: { type: 'string', nullable: true },
            contactInfo: {
                type: 'object',
                properties: {
                    name: { type: 'string' }
                },
                required: ['name']
            },
            onlyDev: { type: 'boolean', nullable: true },
            addresses: {
                type: 'array',
                items: { type: 'string' },
                minItems: 1
            },
            plots: {
                type: 'array',
                items: { type: 'string' },
                minItems: 1
            }
        },
        required: ['name', 'desc', 'contactInfo', 'addresses', 'plots']
    };
    LinkerAuthorization.validate = (0, validation_1.generateLazyValidator)(LinkerAuthorization.schema);
})(LinkerAuthorization = exports.LinkerAuthorization || (exports.LinkerAuthorization = {}));
//# sourceMappingURL=linker-authorization.js.map